import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./DashboardMobile.css";
import { FaAngleDown } from "react-icons/fa";

// Images
import dash from "../../images/dashboard.svg";
import pro from "../../images/profile-2user.svg";
import test from "../../images/test.svg";
import achi from "../../images/achievements1.svg";
import log_b from "../../images/logout-black.svg";
import dash_p from "../../images/dashboard-p.svg";
import pro_p from "../../images/profile-p.svg";
import test_p from "../../images/test-p.svg";
import achi_p from "../../images/achievements-p.svg";
import log_p from "../../images/logout-p.svg";
import side from "../../images/side-menu-mob.svg";
import s4 from "../../images/side-menu4.svg";
import { END_URL,SITE_URL,IMG_URL } from "../../config";
import { useParams } from "react-router-dom";

function DashboardMobile({globaltest,eboookaccess,DashMenu}) {

  // globaltest =  globaltest?.globalTest || [];

  const [tests, setTests] = useState([]);
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [isOpen, setIsOpen] = useState(false); // For "Tests" dropdown
  const [isMenuOpen, setIsMenuOpen] = useState(false); // For mobile menu
  const location = useLocation();
  const ref = useRef();
  const [activeTestPath, setActiveTestPath] = useState("");

    const { slug, test_slug } = useParams();

  // Sync active menu with route
  useEffect(() => {
    if (location.pathname.startsWith("/profile")) {
      setActiveMenu("Profile");
    } else if (location.pathname.startsWith("/result")) {
      setActiveMenu("Dashboard");
    } else if (
      location.pathname === "/ques" ||
      tests.some((test) => test.pathname === location.pathname)
    ) {
      setActiveMenu("Tests");
      setIsOpen(true); // Keep open when any test is active
      setActiveTestPath(location.pathname);
    } else {
      setIsOpen(false);
    }
  }, [location.pathname, tests]);

  // Fetch tests on mount
  useEffect(() => {

    // axios
    //   .get(`${END_URL}/tests`)
    //   .then((response) => {
    //     const updatedTests = response.data.map((test) => {
    //       try {
    //         const url = new URL(test.link, window.location.origin);
    //         return { ...test, pathname: url.pathname };
    //       } catch (e) {
    //         console.error("Invalid test link:", test.link);
    //         return { ...test, pathname: "" };
    //       }
    //     });
    //     setTests(updatedTests);
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching tests:", error);
    //   });


      const updatedTests = globaltest.map((test) => {

          try {
            const url = new URL(test.link, window.location.origin);
            return { ...test, pathname: url.pathname };
          } catch (e) {
            console.error("Invalid test link:", test.link);
            return { ...test, pathname: "" };
          }
        });

        setTests(updatedTests);

  }, [globaltest]);

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  
  const url = localStorage.getItem("url");

  // const menuItems = [
  //   {
  //     id: "Dashboard",
  //     label: "Dashboard",
  //     img: dash_p,
  //     activeImg: dash_p,
  //     route: url,
  //   },
  //   { id: "Profile", label: "Profile", img: pro_p, activeImg: pro_p, route: "/profile" },
  //   { id: "Tests", label: "Tests", img: test_p, activeImg: test_p },

  //    ...(eboookaccess
  //   ? [{
  //       id: "Ebook",
  //       label: "E-Book", 
  //       img: achi_p,
  //       activeImg: achi_p,
  //       route: "/ebook",
  //     }]
  //   : []),

  //   { id: "Achievements", label: "Achievements", img: achi_p, activeImg: achi_p,route: "/achievements", },
  //   { id: "Logout", label: "Logout", img: log_p, activeImg: log_p },
  // ];

  const menuItems = [
      ...DashMenu.map(menu => ({
        id: menu.menu_label,
        label: menu.menu_label,
        route: "/" + menu.menu_link,
        img: menu.menu_file ? `${IMG_URL}/d0/${menu.menu_file}` : test_p,
        activeImg:menu.menu_file ? `${IMG_URL}/d0/${menu.menu_file}` : test_p,
        sublinks: menu.sublinks ?? [] 
      })),
      {
        id: "Logout",
        label: "Logout",
        img: log_p,
        activeImg: log_p,
        route: "/logout",
        sublinks: [] 
      }
  ];

  // const handleMenuClick = (menu) => {
  //   if (menu.id === "Logout") {
  //     handleLogout();
  //   } else {

  //     setActiveMenu(menu.id);

  //     window.location.href = menu.route;
  //     // if (menu.route) {
  //     //   navigate(menu.route);
  //     //   setIsMenuOpen(false); // Close mobile menu after navigation
  //     // }
  //   }
  // };

 const handleMenuClick = (menu) => {

      if (menu.id === "Logout") {
        handleLogout();
      } 
      else if (menu.sublinks && menu.sublinks.length > 0) {
        setIsOpen((prev) => !prev); 
      }
      else {
        setActiveMenu(menu.id);
        setActiveTestPath(menu.route);
        setIsOpen(true);
        navigate(menu.route);
      }
  };

  return (
    <div className="dashboard-mobile">
      <div className="das-mob">
        {/* Hamburger/menu icon for mobile */}
        <div className="dasb-mobile-icon" ref={ref}>
          <div className="dash-mob-title" onClick={() => setIsMenuOpen((prev) => !prev)}>
            <span>
              <img src={side} alt="" />
            </span>
            <span>Menu</span>
            <span className={`arrow-icon ${isMenuOpen ? "rotated" : ""}`}>
              <FaAngleDown />
            </span>
          </div>

          {isMenuOpen && (
            
             <ul className="dash-menus-mob">

                {menuItems.map((menu) => (
                  <li 
                    key={menu.id} 
                    className={menu.sublinks && menu.sublinks.length > 0 ? `drop-down1 ${isOpen ? "open" : ""}` : ""}
                  >
                    {/* Parent Menu Link */}
                    <a
                      className={
                        (!menu.sublinks.length && location.pathname === menu.route) 
                          ? "active-test-item" 
                          : "menu1"
                      }
                      onClick={() => handleMenuClick(menu)}
                      style={{ color: activeMenu === menu.id ? "#88619a" : "#000" }}
                    >
                      <span>
                        <img 
                          src={activeMenu === menu.id ? menu.activeImg : menu.img} 
                          alt={menu.label} 
                        />
                      </span>
                      {menu.label}
                    </a>
    
                    {menu.sublinks && menu.sublinks.length > 0 && isOpen && (
                      <ul>
                        {menu.sublinks.map((sub) => (
                          <li
                            key={sub.id}
                            className={slug === sub.link ? "active-test-item" : ""}
                            onClick={() => {
                              setActiveMenu(menu.id);
                              setActiveTestPath(sub.link);
                              setIsOpen(true);
                              window.location.href = `${SITE_URL}/${sub.link}`;
                            }}
                          >
                            {sub.name}
                          </li>
                        ))}
                      </ul>
                    )}

                  </li>
                ))}
                
            </ul>

          )}
        </div>
      </div>
    </div>
  );
}

export default DashboardMobile;
